<app-hotel-select
  [onlyActive]="false"
  (select)="onSelect($event)"
  [hideLabel]="true"
  [parentFormGroup]="form"
  class="kendo-select-filter"
  [isInModal]="false"
>
</app-hotel-select>
